function customBreadcrumb() {
  const categoryProds = wsMain?.globalData?.listCategoryProds;
  if (!categoryProds) return;

  // "migalha" era o formato legado (v2) de breadcrumb — a API v3 não retorna mais isso em
  // /product/list?source=category; o nome da categoria atual vem em "categoria.nome" (anexado
  // por ApiWS.Calls.listProducts.category() em wsapi3-wsjs.js a partir do "record" bruto da API).
  const actualBreadcrumb = categoryProds.categoria?.nome;
  if (!actualBreadcrumb) return;

  const breadcrumbContainer = document.querySelector(".custom-breadcrumb");
  if (!breadcrumbContainer) return;

  breadcrumbContainer.textContent = `${actualBreadcrumb}`;
}

try {
  isReady("categorias", customBreadcrumb);
} catch (error) {}

function customFilters() {
  setTimeout(() => {
    const container = document.querySelector(".custom-actived-filters-wrapper");
    if (!container) return;
    container.innerHTML = "";
    const filtros = wsMain?.globalData?.infoCategory?.Filtros;

    if (!filtros) return;

    filtros.forEach((filtro) => {
      filtro.opcoes.forEach((opcao) => {
        if (opcao.selecionada === true) {
          const div = document.createElement("a");
          div.className = "custom-actived-filter";
          div.textContent = opcao.nome;

          div.setAttribute(
            "href",
            `${opcao.link}`,
          );

          container.appendChild(div);
        }
      });
    });
  }, 1000);
}

try {
  isReady("categorias", customFilters);
} catch (error) {}

function createCustomSelect() {
  const selectElement = document.getElementById("viewing-order");
  if (!selectElement) return;

  // Cria o container principal
  const customSelectContainer = document.createElement("div");
  customSelectContainer.className = "custom-select-category-filter";

  // Cria o botão que mostra a opção selecionada
  const selectedOption = document.createElement("div");
  selectedOption.className = "custom-select-selected";

  // Pega a opção selecionada atual
  const currentSelected = selectElement.options[selectElement.selectedIndex];
  selectedOption.textContent = currentSelected.textContent;
  selectedOption.setAttribute("data-value", currentSelected.value);

  // Cria o container das opções
  const optionsContainer = document.createElement("div");
  optionsContainer.className = "custom-select-options";
  optionsContainer.style.display = "none";

  // Adiciona cada opção do select original
  Array.from(selectElement.options).forEach((option) => {
    const optionDiv = document.createElement("div");
    optionDiv.className = "custom-select-option";
    optionDiv.textContent = option.textContent;
    optionDiv.setAttribute("data-value", option.value);

    // Marca a opção selecionada
    if (option.selected) {
      optionDiv.classList.add("selected");
    }

    // Evento de clique na opção
    optionDiv.addEventListener("click", function () {
      // Remove a classe 'selected' de todas as opções
      optionsContainer
        .querySelectorAll(".custom-select-option")
        .forEach((opt) => {
          opt.classList.remove("selected");
        });

      // Adiciona a classe 'selected' na opção clicada
      this.classList.add("selected");

      // Atualiza o texto do select customizado
      selectedOption.textContent = this.textContent;
      selectedOption.setAttribute(
        "data-value",
        this.getAttribute("data-value"),
      );

      // Atualiza o select original
      selectElement.value = this.getAttribute("data-value");

      // Dispara o evento onchange do select original
      const event = new Event("change", { bubbles: true });
      selectElement.dispatchEvent(event);

      // Fecha o dropdown
      optionsContainer.style.display = "none";
      customSelectContainer.classList.remove("open");
    });

    optionsContainer.appendChild(optionDiv);
  });

  // Evento de clique para abrir/fechar o dropdown
  selectedOption.addEventListener("click", function (e) {
    e.stopPropagation();
    const isOpen = optionsContainer.style.display === "block";

    // Fecha todos os outros selects customizados abertos
    document
      .querySelectorAll(".custom-select-category-filter")
      .forEach((select) => {
        select.querySelector(".custom-select-options").style.display = "none";
        select.classList.remove("open");
      });

    // Abre/fecha este select
    optionsContainer.style.display = isOpen ? "none" : "block";
    customSelectContainer.classList.toggle("open", !isOpen);
  });

  // Monta a estrutura
  customSelectContainer.appendChild(selectedOption);
  customSelectContainer.appendChild(optionsContainer);

  // Esconde o select original
  selectElement.style.display = "none";

  // Insere o select customizado após o select original
  selectElement.parentNode.insertBefore(
    customSelectContainer,
    selectElement.nextSibling,
  );

  // Fecha o dropdown ao clicar fora
  document.addEventListener("click", function () {
    optionsContainer.style.display = "none";
    customSelectContainer.classList.remove("open");
  });
}

try {
  isReady("product-list", () => {
    setTimeout(createCustomSelect, 500);
  });
} catch (error) {}

class CustomInfinityScroll {
  categoryContainer;
  options = {};
  stringifyOptions;
  canShow = false;

  setOptions() {
    const options = wsMain.tools.getWsData(
      document.querySelector(`[data-wsjs-prod-list="category"]`),
      "options",
    );

    if (options) this.options = { ...options };
  }

  setCategoryContainer() {
    const container = document.querySelector(
      `.list-container > div[data-wsjs-options="false"]`,
    );

    if (!container) {
      setTimeout(() => this.setCategoryContainer(), 500);
      return;
    }

    this.categoryContainer = container;
  }

  treatOptionsToSetAttribute() {
    if (!this.options) return;

    try {
      const strOpts = JSON.stringify(this.options)
        .replaceAll(`"`, "")
        .replaceAll(`,`, ";")
        .replace("{", "")
        .replace("}", "");

      this.stringifyOptions = strOpts;
    } catch {}
  }

  rollbackTagOptions() {
    if (!this.categoryContainer) {
      setTimeout(() => this.rollbackTagOptions(), 500);
      return;
    }

    if (this.stringifyOptions && this.categoryContainer) {
      this.categoryContainer.setAttribute(
        `data-wsjs-options`,
        this.stringifyOptions,
      );

      this.categoryContainer.setAttribute(`data-wsjs-prod-list`, `category`);

      this.canShow = true;
    }
  }

  showProductList() {
    if (!this.canShow) {
      setTimeout(() => this.showProductList(), 500);
      return;
    }

    this.categoryContainer.style.display = `block`;

    this.hideLoader();
  }

  hideLoader() {
    const loader = document.querySelector(`.list-container .category-loader`);

    if (loader) loader.style.display = `none`;
  }

  run() {
    this.setOptions();
    this.treatOptionsToSetAttribute();
    this.setCategoryContainer();
    this.rollbackTagOptions();
    this.showProductList();
  }
}

// try {
//   const infinityScroll = new CustomInfinityScroll();

//   infinityScroll.run();
// } catch (error) {}

function substituirTitulosProdListLast() {
  const titulos = document.querySelectorAll(".prod-list-titles-title-last");

  titulos.forEach((titulo) => {
    titulo.outerHTML = `
      <span class="custom-title-prodlist">
        Últimos que você
        <span class="custom-subtitle-prodlist">visitou</span>
      </span>
    `;
  });
}

try {
  isReady("categorias", substituirTitulosProdListLast);
} catch (error) {}